module.exports = __webpack_public_path__ + "static/media/12346 3203.53ad71ce.ogg";